








































































import {
  Component,
  Mixins,
  Prop,
  Emit,
  Ref,
  Watch,
} from "vue-property-decorator";
import AppToolTip from "#/components/AppToolTip.vue";
import AppDataTable from "#/components/AppDataTable.vue";

import { DataTableHeader } from "vuetify/types/index";
import { PortalJobsearchRecruitee } from "@/model/portal";
import UtilMixin from "@/mixins/utilMixin";
import SelectFilter from "#/components/selectFilter/SelectFilter.vue";
import { SELECT_FILTER } from "#/const";
import {
  ColumnKey,
  HeaderColumn,
  IsFilterMatch,
} from "#/components/selectFilter/filter";

@Component({
  components: {
    AppToolTip,
    SelectFilter,
    AppDataTable,
  },
})
export default class extends Mixins(UtilMixin) {
  /** 送信先求職者情報 */
  @Prop({ default: () => [] }) private value!: PortalJobsearchRecruitee[];

  /** フォーム非活性 */
  @Prop({ default: false }) private disabled!: boolean;

  /** 求職者情報 */
  @Prop({ default: () => [] })
  private recruitees!: PortalJobsearchRecruitee[];

  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  /** 絞込み用キーワード */
  private searchKey = "";

  private get innerValue(): PortalJobsearchRecruitee[] {
    return this.value.slice();
  }

  private set innerValue(newValue: PortalJobsearchRecruitee[]) {
    this.input(newValue);
  }

  @Watch("recruitees") private watchRecruitees(
    newRecruitees: PortalJobsearchRecruitee[]
  ) {
    // NOTE: 表示用の加工。この UI に糖鎖されたフィルタを正常動作させるためにも必要。
    newRecruitees.forEach((recruitee: PortalJobsearchRecruitee) => {
      recruitee.jst_no = "JST" + String(recruitee.id).padStart(7, "0");
      recruitee.full_name = recruitee.family_name + " " + recruitee.first_name;
      if (recruitee.gender == 1) {
        recruitee.gender_name = "男性";
      } else if (recruitee.gender == 2) {
        recruitee.gender_name = "女性";
      }
    });
  }

  /** 選択可能求職者情報 */
  private get srcRecruitees(): PortalJobsearchRecruitee[] {
    if (!this.innerValue.length) {
      return this.recruitees;
    }

    return this.recruitees.filter((recruitee: PortalJobsearchRecruitee) => {
      let match = false;
      this.innerValue.forEach((data: PortalJobsearchRecruitee) => {
        if (recruitee.id == data.id) {
          match = true;
        }
      });
      return !match;
    });
  }

  /** 送信先求職者情報 */
  private get distRecruitees(): PortalJobsearchRecruitee[] {
    return this.innerValue.slice();
  }

  /** 選択可能求職者の中でチェックが入った求職者情報 */
  private selectedSrcRecruitees: PortalJobsearchRecruitee[] = [];

  /** 送信先求職者の中でチェックが入った求職者情報 */
  private selectedDistRecruitees: PortalJobsearchRecruitee[] = [];

  /** 選択可能求職者 -> 送信先求職者への移動 */
  private toDistRecruitees() {
    // 1つもチェックが入っていないままボタンが押された場合は何もしない
    if (!this.selectedSrcRecruitees.length) {
      return;
    }

    // 送信先求職者情報に追加
    this.innerValue = [...this.innerValue, ...this.selectedSrcRecruitees];

    // チェック状態を初期化
    this.selectedSrcRecruitees = [];
  }

  /** 送信先求職者 -> 選択可能求職者への移動 */
  private toSrcRecruitees() {
    // 1つもチェックが入っていないままボタンが押された場合は何もしない
    if (!this.selectedDistRecruitees.length) {
      return;
    }

    // 送信先求職者情報から削除
    this.innerValue = this.innerValue.filter(
      (recruitee: PortalJobsearchRecruitee) => {
        let match = false;
        this.selectedDistRecruitees.forEach(
          (data: PortalJobsearchRecruitee) => {
            if (recruitee.id == data.id) {
              match = true;
            }
          }
        );
        return !match;
      }
    );

    // チェック状態を初期化
    this.selectedDistRecruitees = [];
  }

  /** v-data-table用送る事業所ヘッダー情報 */
  private nonFilterHeaders: DataTableHeader[] = [
    {
      text: "JST番号",
      value: "jst_no",
    },
    {
      text: "名前",
      value: "full_name",
    },
    {
      text: "性別",
      value: "gender_name",
    },
  ];

  /** ヘッダー情報 */
  private get headers(): HeaderColumn[] {
    return [
      {
        text: "JST番号",
        value: "jst_no",
        sortable: true,
        align: "center",
        width: "100px",
        filter: (val: object) => this.columnFilter("jst_no", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "jst_no",
          text: "JST番号",
          selectable: [],
        },
      },
      {
        text: "名前",
        value: "full_name",
        sortable: true,
        align: "center",
        width: "100px",
        filter: (val: object) => this.columnFilter("full_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "full_name",
          text: "名前",
          selectable: [],
        },
      },
      {
        text: "性別",
        value: "gender_name",
        sortable: true,
        align: "center",
        width: "100px",
        filter: (val: object) => this.columnFilter("gender_name", val),
        columnKey: {
          type: SELECT_FILTER.FILTER_TYPE.EDIT,
          key: "gender_name",
          text: "性別",
          selectable: [],
        },
      },
    ];
  }

  /**
   * SelectFilterの選択肢
   * @return ColumnKey
   */
  private get columnKeys(): ColumnKey[] {
    const keys = this.headers
      .filter((headerColumn: HeaderColumn) => headerColumn.filter != null)
      .map((headerColumn: HeaderColumn) => headerColumn.columnKey);

    if (keys.length == 0) {
      return [] as ColumnKey[];
    }

    return keys as ColumnKey[];
  }

  /** カラムフィルター */
  private columnFilter(key: string, val: unknown) {
    const bret = IsFilterMatch(
      this.selectFilter.filterClauses,
      key,
      val as string | number
    );
    return bret;
  }

  @Emit()
  private input(
    newRecruitees: PortalJobsearchRecruitee[]
  ): PortalJobsearchRecruitee[] {
    return newRecruitees;
  }
}
